export default __webpack_public_path__ + "static/media/tex3.1680b7b1.jpg";